import { createLocation } from 'history';
import { Route } from 'mk2/containers/Application/Application';
import { hasRoute } from 'mk2/helpers/router';
import RouterContext from 'mk2/services/RouterContext';
import * as React from 'react';
import { LinkProps, RouteComponentProps, withRouter } from 'react-router-dom'; // tslint:disable-line

interface RouterProps {
    routes: Route[];
}

type Props = RouterProps & LinkProps & RouteComponentProps<{}>;

class Link extends React.PureComponent<Props> {
    public static defaultProps = {
        replace: false,
    };

    public render() {
        const { to, replace, history, location, match, staticContext, innerRef, routes, ...rest } = this.props;

        const href = typeof to === 'string' ? to : history.createHref(to);
        return (
            <a
                {...rest}
                onClick={this.onClick}
                href={href}
                ref={innerRef}
            />
        );
    }

    private onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const { to, onClick, target, replace, history } = this.props;

        const href = event.currentTarget.href;

        if (onClick) {
            onClick(event);
        }

        if (!event.defaultPrevented // onClick prevent default
            && event.button === 0 // ignore everything but left clicks
            && !target // let browser handle "target=_blank" etc.
            && !isModifiedEvent(event) // ignore clicks with modifier keys
            && hasRoute(href, this.props.routes) // Check if we have handler for this URL
        ) {
            event.preventDefault();

            const method = replace ? history.replace : history.push;

            // TODO: This is typescript hack for history.push/replace methods (should be fixed in Typescript 3.x
            if (typeof to === 'string') {
                method(to);
            } else {
                method(to);
            }
        }
    };
}

const LinkWithRoutes: React.StatelessComponent<LinkProps & RouteComponentProps<{}>> = (props) => (
    <RouterContext.Consumer>
        {({ routes }) => (
            <Link {...props} routes={routes} />
        )}
    </RouterContext.Consumer>
);

export default withRouter(LinkWithRoutes);

function isModifiedEvent(event: React.MouseEvent<HTMLAnchorElement>) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
